// src/app/admin/admin-forms/schemas/contacto.schema.ts

import { FormSchema } from '../models/form-schema.model';

export const contactoSchema: FormSchema = {
  id: 'form-contacto',
  title: 'Datos de contacto',
  themeOverride: {
    '--af-color-primary': '#0F6E56',
    '--af-field-radius': '10px',
    '--af-gap': '20px',
  },
  sections: [{
    id: 'seccion-principal',
    columns: 2,
    fields: [
      {
        id: 'nombre',
        type: 'text',
        label: 'Nombre completo',
        colSpan: 2,
        validations: [
          { type: 'required', message: 'El nombre es obligatorio' },
          { type: 'minLength', value: 3, message: 'Mínimo 3 caracteres' }
        ]
      },
      {
        id: 'tipo_doc',
        type: 'select',
        label: 'Tipo de documento',
        options: [
          { value: 'cc', label: 'Cédula de ciudadanía' },
          { value: 'ce', label: 'Cédula de extranjería' }
        ],
        validations: [{ type: 'required', message: 'Seleccione un tipo' }]
      },
      {
        id: 'numero_doc',
        type: 'text',
        label: 'Número de documento',
        conditions: [{
          action: 'show',
          when: 'tipo_doc',
          operator: 'isNotEmpty'
        }]
      }
    ]
  }],
  submitLabel: 'Guardar',
  mode: 'edit'
};